/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type ForcProviderComponent from "parog-web/components/forc/provider";
import type File from "parog-web/models/file";
import type SemeiaSessionService from "parog-web/services/session";
import type DocumentEditionFormComponent from "..";

interface Signature {
  Args: {
    forcComponent: DocumentEditionFormComponent;
    form: ForcProviderComponent;
  };
}

export default class DocumentEditionFormContent extends Component<Signature> {
  @service declare session: SemeiaSessionService;
  @service declare router: RouterService;

  @tracked currentQuestions = [];

  @action
  setCurrentQuestions(questions) {
    this.currentQuestions = questions;
  }

  get changeset() {
    return this.args.forcComponent.changeset;
  }

  get providedForm() {
    return this.args.form;
  }

  /**
   * Callback function which is given
   * to the File upload component.
   * Will be called within the component
   * when upload is successful.
   */
  onSelected(file: File) {
    const files = this.changeset.get("files") as File[];
    const isFirstSelectedFile = Boolean(!files);

    if (isFirstSelectedFile) {
      this.changeset.set("files", [file]);
    } else {
      files.push(file);
      this.changeset.set("files", files);
    }
  }

  @action
  onDocumentTypeChange(key) {
    if (
      this.session.patient?.healthCentre?.disableBioForPatient &&
      key == "bio"
    ) {
      this.router.transitionTo("patient-web.protected.bio-results.edition");
    } else this.changeset.set("documentType", key);
  }

  /**
   * Callback function which is given
   * to the File upload component.
   * Will be called within the component
   * when a file is deleted.
   */
  destroyFile(index: number) {
    const files = this.changeset.get("files") as File[];
    files?.splice(index, 1);

    this.changeset.set("files", files);
  }

  /**
   * File upload accepted types.
   * When upload button is clicked and
   * file explorer opens, only those
   * types would be uploadable.
   */
  get acceptedTypes() {
    return [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/rtf"
    ];
  }
}
